var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSolution1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "617px",
    height: "553px",
    viewBox: "0 0 617 553",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-60.2%",
    y: "-59.3%",
    width: "220.5%",
    height: "218.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-60.2%",
    y: "-59.3%",
    width: "220.5%",
    height: "218.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "StaFihub",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "V2-Copy",
    transform: "translate(-694.000000, -67.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(844.000000, 201.000000)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-23-Copy-2",
    fill: "#FFD5E2",
    opacity: 0.3,
    filter: "url(#filter-1)",
    cx: 192.5,
    cy: 142.5,
    rx: 124.5,
    ry: 126.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-23-Copy-3",
    fill: "#6758FF",
    opacity: 0.3,
    filter: "url(#filter-2)",
    cx: 124.5,
    cy: 142.5,
    rx: 124.5,
    ry: 126.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(12.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#6758FF",
    points: "16.295082 0 169.934426 0 169.934426 31.4766839 16.295082 31.4766839"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-2",
    fill: "#6758FF",
    x: 1.16393443,
    y: 30.3108808,
    width: 153.639344,
    height: 31.4766839
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-4",
    fill: "#8A7FFF",
    points: "16.295082 61.7875648 169.934426 61.7875648 169.934426 93.2642487 16.295082 93.2642487"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-8",
    fill: "#6758FF",
    points: "16.295082 100.259067 169.934426 100.259067 169.934426 131.735751 16.295082 131.735751"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-10",
    fill: "#8A7FFF",
    points: "25.6065574 100.259067 55.8688525 100.259067 55.8688525 131.735751 25.6065574 131.735751"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-6",
    fill: "#6758FF",
    points: "121.04918 61.7875648 274.688525 61.7875648 274.688525 93.2642487 121.04918 93.2642487"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-9",
    fill: "#6758FF",
    points: "121.04918 100.259067 253.737705 100.259067 253.737705 131.735751 121.04918 131.735751"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-12",
    fill: "#6758FF",
    points: "121.04918 131.735751 274.688525 131.735751 274.688525 163.212435 121.04918 163.212435"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-16",
    fill: "#6758FF",
    points: "130.360656 162.046632 284 162.046632 284 193.523316 130.360656 193.523316"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-20",
    fill: "#6758FF",
    points: "130.360656 193.523316 274.688525 193.523316 274.688525 225 130.360656 225"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-21",
    fill: "#6758FF",
    points: "40.7377049 193.523316 128.032787 193.523316 128.032787 225 40.7377049 225"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-17",
    fill: "#6758FF",
    points: "33.7540984 162.046632 130.360656 162.046632 130.360656 193.523316 33.7540984 193.523316"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-11",
    fill: "#8A7FFF",
    points: "96.6065574 100.259067 154.803279 100.259067 154.803279 131.735751 96.6065574 131.735751"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-18",
    fill: "#8A7FFF",
    points: "130.360656 162.046632 188.557377 162.046632 188.557377 193.523316 130.360656 193.523316"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-22",
    fill: "#8A7FFF",
    points: "121.04918 193.523316 197.868852 193.523316 197.868852 225 121.04918 225"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-23",
    fill: "#8A7FFF",
    points: "40.7377049 193.523316 89.6229508 193.523316 89.6229508 225 40.7377049 225"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-19",
    fill: "#6758FF",
    points: "33.7540984 162.046632 64.0163934 162.046632 64.0163934 193.523316 33.7540984 193.523316"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-13",
    fill: "#8A7FFF",
    points: "33.7540984 131.735751 121.04918 131.735751 121.04918 163.212435 33.7540984 163.212435"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-14",
    fill: "#6758FF",
    points: "48.8852459 131.735751 79.147541 131.735751 79.147541 163.212435 48.8852459 163.212435"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-15",
    fill: "#8A7FFF",
    points: "121.04918 131.735751 169.934426 131.735751 169.934426 163.212435 121.04918 163.212435"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy",
    fill: "#B16BD4",
    points: "16.295082 0 65.1803279 0 65.1803279 31.4766839 16.295082 31.4766839"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-3",
    fill: "#B16BD4",
    points: "1.16393443 30.3108808 50.0491803 30.3108808 50.0491803 61.7875648 1.16393443 61.7875648"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-5",
    fill: "#B16BD4",
    points: "16.295082 61.7875648 65.1803279 61.7875648 65.1803279 93.2642487 16.295082 93.2642487"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-7",
    fill: "#B16BD4",
    points: "121.04918 61.7875648 169.934426 61.7875648 169.934426 93.2642487 121.04918 93.2642487"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-19",
    fill: "#6758FF",
    x: 0,
    y: 30.3108808,
    width: 48.8852459,
    height: 10.492228
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-19-Copy-3",
    fill: "#6758FF",
    points: "15.1311475 61.7875648 64.0163934 61.7875648 64.0163934 72.2797927 15.1311475 72.2797927"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-19-Copy",
    fill: "#B16BD4",
    points: "25.6065574 100.259067 55.8688525 100.259067 55.8688525 115.414508 25.6065574 115.414508"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-19-Copy-6",
    fill: "#B16BD4",
    points: "48.8852459 131.735751 79.147541 131.735751 79.147541 146.891192 48.8852459 146.891192"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-19-Copy-7",
    fill: "#B16BD4",
    points: "33.7540984 162.046632 64.0163934 162.046632 64.0163934 177.202073 33.7540984 177.202073"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-19-Copy-2",
    fill: "#B16BD4",
    points: "96.6065574 100.259067 154.803279 100.259067 154.803279 115.414508 96.6065574 115.414508"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-19-Copy-4",
    fill: "#6758FF",
    points: "121.04918 131.735751 169.934426 131.735751 169.934426 146.891192 121.04918 146.891192"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-19-Copy-5",
    fill: "#B16BD4",
    points: "130.360656 162.046632 188.557377 162.046632 188.557377 177.202073 130.360656 177.202073"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-20",
    fill: "#FF7FA7",
    points: "53.5409836 9.32642487 68.6721311 9.32642487 68.6721311 11.6580311 53.5409836 11.6580311"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-20-Copy-9",
    fill: "#FF7FA7",
    points: "53.5409836 76.9430052 68.6721311 76.9430052 68.6721311 79.2746114 53.5409836 79.2746114"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-20-Copy-10",
    fill: "#FF7FA7",
    points: "32.5901639 68.7823834 67.5081967 68.7823834 67.5081967 71.1139896 32.5901639 71.1139896"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-20-Copy-2",
    fill: "#FF7FA7",
    points: "138.508197 9.32642487 169.934426 9.32642487 169.934426 11.6580311 138.508197 11.6580311"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-20-Copy-15",
    fill: "#FF7FA7",
    points: "244.42623 142.227979 275.852459 142.227979 275.852459 144.559585 244.42623 144.559585"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-20-Copy-23",
    fill: "#FF7FA7",
    points: "182.737705 202.849741 214.163934 202.849741 214.163934 205.181347 182.737705 205.181347"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-20-Copy-4",
    fill: "#FF7FA7",
    points: "68.6721311 139.896373 108.245902 139.896373 108.245902 142.227979 68.6721311 142.227979"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-20-Copy-13",
    fill: "#FF7FA7",
    points: "135.016393 139.896373 174.590164 139.896373 174.590164 142.227979 135.016393 142.227979"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-20-Copy-17",
    fill: "#FF7FA7",
    points: "164.114754 171.373057 179.245902 171.373057 179.245902 173.704663 164.114754 173.704663"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-20-Copy-19",
    fill: "#FF7FA7",
    points: "124.540984 171.373057 139.672131 171.373057 139.672131 173.704663 124.540984 173.704663"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-20-Copy-7",
    fill: "#FF7FA7",
    points: "114.065574 73.4455959 210.672131 73.4455959 210.672131 75.7772021 114.065574 75.7772021"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-20-Copy-11",
    fill: "#FF7FA7",
    points: "88.4590164 109.585492 165.278689 109.585492 165.278689 111.917098 88.4590164 111.917098"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-20-Copy",
    fill: "#FF7FA7",
    points: "17.4590164 20.984456 48.8852459 20.984456 48.8852459 23.3160622 17.4590164 23.3160622"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-20-Copy-6",
    fill: "#FF7FA7",
    points: "17.4590164 52.4611399 57.0327869 52.4611399 57.0327869 54.7927461 17.4590164 54.7927461"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-20-Copy-21",
    fill: "#FF7FA7",
    points: "50.0491803 180.699482 89.6229508 180.699482 89.6229508 183.031088 50.0491803 183.031088"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-20-Copy-22",
    fill: "#FF7FA7",
    points: "50.0491803 169.041451 89.6229508 169.041451 89.6229508 171.373057 50.0491803 171.373057"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-20-Copy-3",
    fill: "#FF7FA7",
    points: "159.459016 20.984456 169.934426 20.984456 169.934426 23.3160622 159.459016 23.3160622"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-20-Copy-16",
    fill: "#FF7FA7",
    points: "264.213115 153.88601 274.688525 153.88601 274.688525 156.217617 264.213115 156.217617"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-20-Copy-24",
    fill: "#FF7FA7",
    transform: "translate(189.721311, 218.005181) scale(1, -1) translate(-189.721311, -218.005181) ",
    points: "165.278689 216.839378 214.163934 216.839378 214.163934 219.170984 165.278689 219.170984"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-20-Copy-5",
    fill: "#FF7FA7",
    points: "94.2786885 150.388601 108.245902 150.388601 108.245902 152.720207 94.2786885 152.720207"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-20-Copy-14",
    fill: "#FF7FA7",
    points: "160.622951 150.388601 174.590164 150.388601 174.590164 152.720207 160.622951 152.720207"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-20-Copy-18",
    fill: "#FF7FA7",
    points: "173.42623 181.865285 179.245902 181.865285 179.245902 184.196891 173.42623 184.196891"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-20-Copy-20",
    fill: "#FF7FA7",
    points: "133.852459 181.865285 139.672131 181.865285 139.672131 184.196891 133.852459 184.196891"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-20-Copy-8",
    fill: "#FF7FA7",
    points: "178.081967 83.9378238 210.672131 83.9378238 210.672131 86.2694301 178.081967 86.2694301"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-20-Copy-12",
    fill: "#FF7FA7",
    transform: "translate(103.590164, 117.746114) scale(1, -1) translate(-103.590164, -117.746114) ",
    points: "40.7377049 116.580311 166.442623 116.580311 166.442623 118.911917 40.7377049 118.911917"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-21",
    fill: "#FF7FA7",
    x: 28,
    y: 223,
    width: 193,
    height: 2
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolution1);
export default __webpack_public_path__ + "static/media/solution1.09774c8a9e9c5026cd575a3b6e061a26.svg";
export { ForwardRef as ReactComponent };